import Api from "./Api";

const endpoint = "/abrechnung_gast";
export default {
    get(werkId) {
        return Api.fetchData(endpoint + "/werk/" + werkId);
    },
    contracts(werkId) {
        return Api.fetchData(endpoint + "/werk/" + werkId + "/contract");
    },
    contract(werkId, mitgliedId) {
        return Api.fetchData(
            endpoint + "/werk/" + werkId + "/contract/" + mitgliedId
        );
    }
};
